import { makeStyles } from "tss-react/mui";

export const useCreateProjectFormStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    padding: 16,
  },
  dialog: {
    padding: "35px",

    "& .MuiFormHelperText-root": {
      textAlign: "end",
    },

    "& .MuiPaper-root": {
      maxWidth: 700,
    },
  },
  sourceSelectionDialog:{
    "& .MuiPaper-root": {
      maxWidth: 690,
      maxHeight: 730,
    },
  },
  box:{
    display:"flex",
    flexDirection:"column",
  },
  btnBack: {
    fontSize: "1rem",
    width: 130,
    marginLeft:-30
  },
  backIcon: {
    marginRight: 4,
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: 16,
    gap: "10px",
  },  
  errorLink: {
    textDecoration: "underline",
  },
  sources: {    
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    gap: "24px",
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",    
    overflowX: "hidden", 
    overflowY: "auto", 
    marginBottom: "40px",
    "& .button-container": {
      gridColumn: "span 2",
      display: "block", 
      textAlign: "center",
      "& button" : {
        minWidth: "70%"
      },
      "&:last-child" : {
        "&:nth-child(3n-1)":{ 
          gridColumnEnd: -2
        } , 
        "&:nth-child(3n-2)":{
          gridColumnEnd: 5
        }
      },
      "&:nth-last-child(2)" : {
        "&:nth-child(3n+1)":{ 
          gridColumnEnd: 4
        },
      }
    }
  },
  title: {
    fontWeight: "bold",
    fontSize: "20px",
    width: "80%",
    marginLeft: 0,
  },
  message: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "justify",
  },
  sourceImg:{
    "& .MuiSvgIcon-root" : {
        width: "94px",
        height: "94px"
    }, 
    backgroundRepeat:"no-repeat",
    backgroundSize: "cover",
    display:"grid",
    gridTemplateColumns: "1fr",
    flexDirection:"row",
    alignItems: "flex-end",
    justifyContent: "center"
  },
  dataIcon: {
    fontSize: 94,
    color: "var(--color-purple-500) !important",
  }, 
  dataBaseImg:{
    "& .MuiSvgIcon-root" : {
        width: "94px",
        height: "94px"
    }, 
    backgroundRepeat:"no-repeat",
    backgroundSize: "cover",
    display:"grid",
    gridTemplateColumns: "1fr",
    flexDirection:"row",
    alignItems: "flex-end",
    justifyContent: "center"
  },
  infoSpan:{
    alignItems: "flex-start",
  },
  messageTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: 50,
    alignSelf: "start",
  },
  messageBody: {
    fontSize: "1rem",
    lineHeight: "2rem",
    "& div": {
      marginBottom: 24,
    },
    "& div:last-child": {
      marginBottom: 0,
    },
  },
  btnDefault: {
    width: "auto",
    minWidth: 100,
  },
  dialogTitle: {
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: 0,
    marginLeft: 35,
  },
  content: {
    display: "flex",
    padding: "24px 40px 40px",
    gap: 32,
    alignItems: "start",
    justifyContent: "center",
  },
  item: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  },
  description: {
    fontSize: 14,
    color: "var(--color-neutral-400) !important",
    fontWeight: 400,
    lineHeight: "1.6rem",
    textAlign : "center"

  },
  info: {
    height: 188,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 5,
    border: "2px solid var(--color-supp-light)",
    borderRadius: 4,
    boxShadow: "0 0 10 var(--color-accent-medium)",
    cursor: "pointer",
    padding: "24px px",
    span: {
      fontWeight: 600,
      fontsize: 14,
      color: "var(--color-neutral-800) !important", 
    },

    "&:hover": {
      borderColor: "var(--color-accent-medium)",
      boxShadow: "0 0 10px var(--color-accent-light)",
      backgroundColor:"#E2F6FC"
    },    
  },
  projectIdField: {
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main,
    },
    "& .MuiInputBase-root": {
      height: 44,
      borderRadius: 6,
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 12px",
      lineHeight: "24px",
      fontSize: 14,
    },
  },
  addDatasetBtn: {
    "--button-color": "var(--color-neutral-white)",
  },
  form: {
    position: "relative",
    height:"60vh",
  },
  formItem: {
    display: "flex",
    width: "100%",
    overflowY: "auto",
    flexDirection: "column",
    marginBottom: "20px",
  },
  dynamiclabel:{
    display: "flex",
    flexDirection:"row",
    justifyContent:"flex-start",
    alignItems:"start",
    width: "100%",
  },
  labelWrapper:{
    display: "flex",
    flexDirection:"column",
  },
  headerlabel: {
    fontWeight: 600,
    letterSpacing: 0,
    lineHeight: "100%",
    fontSize: "20px",
    marginBottom: "16px",
  },
  label: {
    fontWeight: 600,
    letterSpacing: "114.99",
    lineHeight: "100%",
    fontSize: "16px",
    marginBottom: "8px",
  },
  labelvalue:{
    lineHeight:"normal",
    marginBottom: "32px",
  },
  halfWidth: {
    width: "70%"
  },
  input: {
    "& .MuiInputBase-root": {
      height: 44,                 // enforce overall control height
      borderRadius: 6,            // optional: match design if rounded
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 12px",       // vertical padding to center text inside 44px
      lineHeight: "24px",
      fontSize: 14,
    },
  },
}));
